var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIdentity = function SvgIdentity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76.436,
    height: 76.436,
    viewBox: "0 0 76.436 76.436",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".identity{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "identity",
    d: "M48.414,24.633,59.61,0h-18.2l-3.08,6.686L35.339,0H16.826l11.2,24.633H0v51.8H76.436v-51.8ZM44.28,4.479h8.375L43.494,24.633H35Zm-11.842,0,3.406,7.61-4.33,9.4L23.781,4.479Zm39.52,67.478H4.479V29.111H71.957Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "identity",
    d: "M297,245h21.647v4.479H297Z",
    transform: "translate(-252.661 -208.424)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "identity",
    d: "M297,325.5h21.647v4.479H297Z",
    transform: "translate(-252.661 -276.907)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "identity",
    d: "M297,406h21.647v4.479H297Z",
    transform: "translate(-252.661 -345.389)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "identity",
    d: "M81.388,259a7.836,7.836,0,1,0-9.666,0C65.958,260.437,62,264.59,62,270.858v2.656H91.111v-2.656C91.111,264.682,87.252,260.458,81.388,259Zm-4.836-9.521a3.359,3.359,0,1,1-3.356,3.355A3.363,3.363,0,0,1,76.552,249.479Zm-9.9,19.557c1.163-5.646,7.748-6.121,9.9-6.121s8.737.475,9.9,6.121Z",
    transform: "translate(-52.744 -208.424)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIdentity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/identity.8f6e7839.svg";
export { ForwardRef as ReactComponent };